export default __webpack_public_path__ + "static/media/shop2.9dc4fcec.jpg";